export default __webpack_public_path__ + "static/media/ownr_direct_indirect.cc526139.svg";